<template>

  <template v-if="mode === 'view'">
        <v-sheet class="d-flex flex-wrap">
          <v-sheet
            v-for="col in meta.columns"
            :key="col"
          >
            <v-card
              v-if= "value[col.fieldname]"
              :title= col.title
              variant= outlined
              class="mx-1 my-1"
            > 
              <v-card-text>
                <base-geo-cell v-bind="{mode:'view', column:col, meta:meta, rowobject:value}" v-model="value[col.fieldname]" /> 
              </v-card-text>
            </v-card>

            <v-card
              v-if= "value[col.fieldname]==undefined"
              :title= col.title
              variant= flat
              color="vs"
              class="mx-1 my-1"
            > 
              <v-card-text>
                <p> &nbsp; </p>
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-sheet>
  </template>    

  <template v-else>
      {{v}}
  </template>
  
</template>

<script>
import BaseGeoCell from '@/components/BaseGeoCell.vue';
export default {
    name: 'StandardDataMaterial',
    props:['mode','meta', 'value'],
    emits: ['update:modelValue'],
    data(){ 
        return {
            v: this.value,
        }
    }, 
    
    components: {
    BaseGeoCell,

    },



}
</script>